import apiClient from './client';

export const botMessagesApi = {
  list: (params) => apiClient.get('/api/bot-messages', { params }),
  getById: (id) => apiClient.get(`/api/bot-messages/${id}`),
  create: (data) => apiClient.post('/api/bot-messages', data),
  update: (id, data) => apiClient.put(`/api/bot-messages/${id}`, data),
  remove: (id) => apiClient.delete(`/api/bot-messages/${id}`),
};

export default botMessagesApi;
